import axios from "axios";
import router from "@/router/index";
import store from "@/store";
import resetMessage from "../../common/resetMessage";
import { BASE_ENV } from "@public/utils/const";
import { arr, objKeySort, deleteNullKey, transferText } from "../utils/common";
import md5 from "js-md5";
import _ from "lodash";
import qs from "qs";

// 验签
const signKey = BASE_ENV().signKey;
// 创建axios实例
const service = axios.create();
// 设置请求的基础路径
service.defaults.baseURL = process.env.VUE_APP_API_URL;
// 超时时间
service.defaults.timeout = 15000;
// request拦截器
service.interceptors.request.use(
  (config) => {
    // 获取vuex的token
    const { token = "" } = store.getters;
    /* 验签兼容get请求 */
    config.data = config.data || {};
    if (config.method === "get") {
      if (config.url.indexOf("?") > 0) {
        config.data = qs.parse(config.url.split("?")[1]);
      } else {
        config.data = config.params || {};
      }
    }
    // 设置请求头authToken
    config.headers.authToken = token;
    // 国际化需要国际化标识
    config.headers.langType = store.state.base.lang;
    // 接口需要国际化字段
    config.headers.language = store.state.base.lang;
    // 接口需要ts
    const _url = config.url;
    // if (arr.includes(_url)) {
    const _time = new Date().getTime();
    config.headers.ts = _time;
    config.headers.sysCode = 'web'
    const param0 = _.cloneDeep(config.data);
    const params = deleteNullKey(param0);
    const param = objKeySort(params);
    const reg = new RegExp('"', 'g')
    const key = `${JSON.stringify(param)}&ts=${_time}&signKey=${signKey}`.replace(reg, '');
    const md5UpperCase = md5(key).toUpperCase();
    config.headers.tmpSign = md5UpperCase;
    // }
    //  设置了缓存，如果请求参数没变又要实时返回，请在请求后面加时间戳
    config.headers["Cache-Control"] = "max-age=2, must-revalidate";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      var res = response.data;
      /* 处理特殊字符转义 */
      if (res.data) {
        res.data = JSON.parse(transferText(JSON.stringify(res.data)))
      }

      if (((res && res.code === 401) || res.code === 4001) || (res && res.code === 402) || res.code === 4002) {
        // token失效
        store.dispatch("LOGIN_OUT");
        router.push("/login");
        //   location.reload()
      } else if (res && res.code === 4003) {
        resetMessage.error({
          message: res.msg
        });
        store.dispatch("LOGIN_OUT");
        router.push("/login");
      } else if (
        res &&
        res.code !== 1 && res.code !== 500004 && res.code !== 500012 &&
        response.config.responseType !== "arraybuffer"
      ) {
        resetMessage.error({
          message: res.msg
        });
      }
      return res;
    }
  },
  (error) => {
    if (
      error.response &&
      error.response.status &&
      error.response.status == 401
    ) {
      // token失效
      store.dispatch("LOGIN_OUT");
      router.push("/login");
      // location.reload()
    }
    return Promise.reject(error);
  }
);
export const get = (url, params) => service.get(url, { params });
export const post = service.post;
export const put = service.put;
export const del = service.delete;

export default service;
